<template>
  <footer class="footer">
    <div class="container-fluid d-flex flex-wrap justify-content-between">
      <nav>
        <ul>
          <li>
            <router-link :to="{ path: '/' }" id="home">
              Accueil
              <b-tooltip target="#home">
                Retourner à la page d'accueil
              </b-tooltip>
            </router-link>
          </li>
          <li>
            <a :href="supportUrl" target="_blank" id="support">
              Aide
              <b-tooltip target="#support">
                Contacter le service support de MonAIOT
              </b-tooltip>
            </a>
          </li>
          <li>
            <a :href="mentionsLegalesUrl" target="_blank" id="mentions-legales">
              Mentions légales
              <b-tooltip target="#mentions-legales">
                Accéder aux modalités d'usage des données
              </b-tooltip>
            </a>
          </li>
        </ul>
      </nav>
      <div class="copyright text-center">
        &copy; <a :href="brgmUrl" target="_blank" id="brgm">
        BRGM
        <b-tooltip target="#brgm">
          Retrouvez le site officiel du BRGM
        </b-tooltip>
      </a>
      </div>
    </div>
  </footer>
</template>
<script>
import {BTooltip} from "bootstrap-vue-next";
import { env } from "../../env";

export default {
  components: {BTooltip},
  data() {
    return {
      brgmUrl : env.brgmUrl,
      supportUrl : env.supportUrl,
      mentionsLegalesUrl : env.mentionsLegalesUrl
    }
  }
};
</script>
<style lang="scss">
  .footer {
    @media screen and (max-width: 992px) {
      nav {
        margin: 0 auto !important;
        li {
          margin: 15px 0 !important;
        }
      }
    }
  }
</style>
